import { useCallback, useEffect, useState } from "react";
import { api } from "../api";
import { UI_TICK_INTERVAL_MS } from "../lib/time";

export const useLotData = () => {
  const [spaces, setSpaces] = useState([]);
  const [stats, setStats] = useState({});
  const [logs, setLogs] = useState([]);
  const [now, setNow] = useState(Date.now());

  const refresh = useCallback(async () => {
    const [s, st, lg] = await Promise.all([api.spaces(), api.stats(), api.logs()]);
    setSpaces(s);
    setStats(st);
    setLogs(lg);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), UI_TICK_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return { spaces, stats, logs, now, refresh };
};
